module.exports = __webpack_public_path__ + "static/media/modal_mixed_icon.c0c1fd78.svg";